const rootRoute = {
  path: '*',
  redirect: '/',
};

export default rootRoute;
